export default __webpack_public_path__ + "static/media/PhysicalDescriptions_00.056c77b6.png";